exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".drop-zone{border:dashed 2px lightgray;padding:10px;text-align:center}.nv-file-over{border:dashed 2px greenyellow;background-color:#efffd7}\n", ""]);
